import MemberDetails from 'gcs-common/components/InfoPanel/MemberDetails/MemberDetails';
import { RIGHT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import { getMemberDetailsSelectedUserId } from 'gcs-common/slices/memberDetails/memberDetailsSelectors';
import { setRightBarTab } from 'gcs-common/slices/uiState/uiStateSlice';
import { useDispatch, useSelector } from 'react-redux';
import ProfileHeader from '../ProfileHeader/ProfileHeader';

const UserProfile = () => {
  const selectedUserId = useSelector(getMemberDetailsSelectedUserId);
  const dispatch = useDispatch();
  const onBack = () => {
    dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.CHANNEL_DETAILS }));
  };

  return (
    <div className="flex flex-col overflow-y-auto pb-10">
      <ProfileHeader title="Profil" onBack={onBack} />

      <MemberDetails selectedUserId={selectedUserId} onBack={onBack} />
    </div>
  );
};

export default UserProfile;
